import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-4" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "text-fprimary fw-bolder" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-vcard fs-1 me-3 text-fprimary" }, null, -1)
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "form-group row mb-0" }
const _hoisted_9 = { class: "col-sm-4" }
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "form-control form-control-solid border py-2" }
const _hoisted_12 = { class: "col-sm-4" }
const _hoisted_13 = { class: "col-sm-4" }
const _hoisted_14 = { class: "form-group row mb-0" }
const _hoisted_15 = { class: "col-sm-4" }
const _hoisted_16 = { class: "col-sm-4" }
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = { class: "form-group row mb-0" }
const _hoisted_19 = { class: "col-sm-4" }
const _hoisted_20 = { class: "col-sm-4 d-none" }
const _hoisted_21 = { class: "col-sm-4" }
const _hoisted_22 = { class: "text-fprimary fw-bolder my-6 border-bottom pb-2" }
const _hoisted_23 = { class: "form-group row mb-0" }
const _hoisted_24 = { class: "col-sm-6" }
const _hoisted_25 = { class: "col-sm-6" }
const _hoisted_26 = { class: "text-fprimary fw-bolder my-6 border-bottom pb-2" }
const _hoisted_27 = { class: "form-group row mb-0" }
const _hoisted_28 = { class: "col-sm-2" }
const _hoisted_29 = { class: "col-sm-2" }
const _hoisted_30 = { class: "mb-2" }
const _hoisted_31 = { class: "col-sm-4" }
const _hoisted_32 = { class: "col-sm-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "mb-2" }, "Email (2)", -1)
const _hoisted_34 = { class: "text-fprimary fw-bolder my-6 border-bottom pb-2" }
const _hoisted_35 = { class: "form-group row mb-5" }
const _hoisted_36 = { class: "col-sm-3 d-none" }
const _hoisted_37 = { class: "col-sm-3" }
const _hoisted_38 = { class: "col-sm-3" }
const _hoisted_39 = { class: "col-sm-3" }
const _hoisted_40 = { class: "row form-group" }
const _hoisted_41 = { class: "col-sm-8" }
const _hoisted_42 = { class: "d-flex justify-content-between" }
const _hoisted_43 = { class: "card-title" }
const _hoisted_44 = { class: "fs-6 text-fprimary fw-bolder" }
const _hoisted_45 = { class: "card-toolbar" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus fs-2 me-3 text-white" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash fs-2 text-hover-danger me-4 cursor-pointer" }, null, -1)
const _hoisted_48 = { class: "col-sm-4" }
const _hoisted_49 = { class: "mb-2" }
const _hoisted_50 = {
  key: 0,
  class: "row form-group"
}
const _hoisted_51 = { class: "col-sm-4" }
const _hoisted_52 = { class: "row m-0" }
const _hoisted_53 = { class: "col-sm-12 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ModalAlergyPerson = _resolveComponent("ModalAlergyPerson")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.t('person1')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitForm(_ctx.swFormRef)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.swForm.idpayroll != null ? _ctx.t('update') : _ctx.t('save')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_form, {
          ref: "swFormRef",
          model: _ctx.swForm,
          rules: _ctx.rules,
          class: "form form-label-right",
          "label-position": 'top'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t('person2')), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.swForm.idpayroll != null ? (_ctx.swForm.idclub + _ctx.swForm.idperson + _ctx.swForm.idpayroll) :
                                '***000'), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.t('typeDocument'),
                  prop: "doctype",
                  rules: [{
                            required: true,
                            message: _ctx.t('obligatorie'),
                            trigger: ['blur', 'change'],
                        }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.swForm.doctype,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.swForm.doctype) = $event)),
                      class: "w-100",
                      placeholder: _ctx.t('seleccione'),
                      onChange: _ctx.changeDocType
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDocuments, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            value: item.id,
                            label: item.name
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.t('nroDocument'),
                  prop: "docnumber",
                  rules: [
                            { required: true, message: _ctx.t('obligatorie'), trigger: ['change', 'blur'] },
                            { min: _ctx.minlength, message: `Campo requiere ${_ctx.maxlength} dígitos`, trigger: ['change', 'blur'] },
                            { pattern: _ctx.pattern, message: 'Solo números', trigger: ['change', 'blur'] }
                        ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      ref: "inputRef",
                      placeholder: _ctx.t('nroDocument'),
                      modelValue: _ctx.swForm.docnumber,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.swForm.docnumber) = $event)),
                      modelModifiers: { trim: true },
                      minlength: _ctx.minlength,
                      maxlength: _ctx.maxlength,
                      "show-word-limit": true
                    }, null, 8, ["placeholder", "modelValue", "minlength", "maxlength"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_el_form_item, {
                  prop: "firstname",
                  label: _ctx.t('FamilyName'),
                  rules: [{
                            required: true,
                            message: _ctx.t('obligatorie'),
                            trigger: ['blur', 'change']
                        }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.swForm.firstname,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.swForm.firstname) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_form_item, {
                  prop: "lastname",
                  label: _ctx.t('person3'),
                  rules: [{
                            required: true,
                            message: _ctx.t('obligatorie'),
                            trigger: ['blur', 'change']
                        }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.swForm.lastname,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.swForm.lastname) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_el_form_item, {
                  prop: "surname",
                  label: _ctx.t('person4'),
                  rules: [{
                            required: false,
                            message: _ctx.t('obligatorie'),
                            trigger: ['blur', 'change']
                        }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.swForm.surname,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.swForm.surname) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_el_form_item, {
                  prop: "gender",
                  label: _ctx.t('gender'),
                  rules: [{
                            required: true,
                            message: _ctx.t('obligatorie'),
                            trigger: 'change'
                        }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.swForm.gender,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.swForm.gender) = $event)),
                      class: "w-100"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGender, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_radio_button, {
                            key: index,
                            label: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_el_form_item, {
                  prop: "marital_status",
                  label: "Estado civil",
                  rules: [{
                            required: false,
                            message: _ctx.t('obligatorie'),
                            change: 'change'
                        }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: _ctx.t('seleccione'),
                      class: "w-100",
                      modelValue: _ctx.swForm.marital_status,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.swForm.marital_status) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maritalStatus, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["placeholder", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["rules"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_el_form_item, {
                  prop: "birthday",
                  label: _ctx.t('birthday'),
                  rules: [{
                            required: true,
                            message: _ctx.t('obligatorie'),
                            change: ['blur', 'change']
                        }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.swForm.birthday,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.swForm.birthday) = $event)),
                      type: "date",
                      placeholder: "dd/mm/yyyy",
                      format: "DD/MM/YYYY",
                      "value-format": "YYYY-MM-DD",
                      class: "w-100",
                      onBlur: _ctx.handleBlur
                    }, null, 8, ["modelValue", "onBlur"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ])
            ]),
            _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.t('person5')) + ":", 1),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.t('country'),
                  prop: "idcountry",
                  rules: [{
                            required: true,
                            message: _ctx.t('obligatorie'),
                            change: 'change'
                        }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.swForm.idcountry,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.swForm.idcountry) = $event)),
                      filterable: "",
                      placeholder: _ctx.t('seleccione'),
                      class: "w-100"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCountry, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.idcountry,
                            label: item.name,
                            value: item.idcountry
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_el_form_item, {
                  prop: "address",
                  label: _ctx.t('address'),
                  rules: [{
                            required: false,
                            message: _ctx.t('obligatorie'),
                            trigger: ['blur', 'change']
                        }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.swForm.address,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.swForm.address) = $event)),
                      maxlength: "300"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ])
            ]),
            _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.t('person6')) + ":", 1),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_el_form_item, {
                  prop: "phone1",
                  label: `${_ctx.t('mobile')} (1)`,
                  rules: [{
                            required: true,
                            message: _ctx.t('obligatorie'),
                            trigger: ['blur', 'change']
                        }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.swForm.phone1,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.swForm.phone1) = $event)),
                      maxlength: "17"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(`${_ctx.t('mobile')} (2)`), 1),
                _createVNode(_component_el_form_item, { prop: "phone2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.swForm.phone2,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.swForm.phone2) = $event)),
                      maxlength: "17"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_el_form_item, {
                  prop: "email1",
                  label: "Email (1)",
                  rules: [{
                            required: true,
                            message: _ctx.t('obligatorie'),
                            trigger: ['blur', 'change']
                        },
                        {
                            type: 'email',
                            message: 'Ingrese un email válido',
                            trigger: ['blur', 'change']
                        }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.swForm.email1,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.swForm.email1) = $event)),
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["rules"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_el_form_item, { prop: "email2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.swForm.email2,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.swForm.email2) = $event)),
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("h3", _hoisted_34, _toDisplayString(_ctx.t('person7')) + ":", 1),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_el_form_item, {
                  label: "Ocupación",
                  prop: "ocupation"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.swForm.ocupation,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.swForm.ocupation) = $event)),
                      placeholder: _ctx.t('seleccione'),
                      class: "w-100"
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.t('person8'),
                  prop: "blood_type",
                  rules: [{
                            required: true,
                            message: _ctx.t('obligatorie'),
                            change: 'change'
                        }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.swForm.blood_type,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.swForm.blood_type) = $event)),
                      placeholder: _ctx.t('seleccione'),
                      class: "w-100"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bloodType, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.t('person9'),
                  prop: "stature"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.swForm.stature,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.swForm.stature) = $event)),
                      maxlength: "3"
                    }, {
                      append: _withCtx(() => [
                        _createTextVNode("cm")
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.t('person10'),
                  prop: "weight"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.swForm.peso,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.swForm.peso) = $event)),
                      maxlength: "3"
                    }, {
                      append: _withCtx(() => [
                        _createTextVNode("Kg")
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("h3", _hoisted_44, _toDisplayString(_ctx.t('person11')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_el_button, {
                      color: "#E71D2E",
                      size: "small",
                      onClick: _ctx.oPenDialogAlergy
                    }, {
                      default: _withCtx(() => [
                        _hoisted_46,
                        _createTextVNode(_toDisplayString(_ctx.t('add')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _createVNode(_component_el_table, {
                  data: _ctx.listAllergy,
                  stripe: "",
                  "table-layout": 'fixed',
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "name",
                      label: _ctx.t('person13')
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      prop: "severityName",
                      label: _ctx.t('person14')
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      prop: "reactions",
                      label: _ctx.t('person15')
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      label: "OP",
                      width: "60"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createVNode(_component_el_popconfirm, {
                          title: `Eliminar ${row.name}?`,
                          width: "220",
                          "confirm-button-text": "SI",
                          onConfirm: ($event: any) => (_ctx.deleteAllergy(row))
                        }, {
                          reference: _withCtx(() => [
                            _hoisted_47
                          ]),
                          _: 2
                        }, 1032, ["title", "onConfirm"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ])), [
                [_directive_loading, _ctx.loaderAllergy]
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.t('person12')), 1),
                _createVNode(_component_el_form_item, { prop: "ocupation" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.swForm.ocupation,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.swForm.ocupation) = $event)),
                      placeholder: _ctx.t('seleccione'),
                      class: "w-100",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: 'VEGETARIANO',
                          value: 'VEGETARIANO'
                        }),
                        _createVNode(_component_el_option, {
                          label: 'VEGANO',
                          value: 'VEGANO'
                        }),
                        _createVNode(_component_el_option, {
                          label: 'SIN GLUTEN',
                          value: 'SIN GLUTEN'
                        }),
                        _createVNode(_component_el_option, {
                          label: 'SIN LACTOSA',
                          value: 'SIN LACTOSA'
                        }),
                        _createVNode(_component_el_option, {
                          label: 'SIN RESTRICCIONES',
                          value: 'SIN RESTRICCIONES'
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            (_ctx.getUsername?.idperfil == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createVNode(_component_el_form_item, {
                      prop: "user_created",
                      label: "User name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.swForm.user_created,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.swForm.user_created) = $event)),
                          placeholder: "Nombre de usuario",
                          maxlength: "50"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])), [
      [_directive_loading, _ctx.loader]
    ]),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        (_ctx.action == 1 || _ctx.action == 2)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.submitForm(_ctx.swFormRef)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.swForm.idpayroll != null ? _ctx.t('update') : _ctx.t('save')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ModalAlergyPerson, {
      params: _ctx.params,
      action: _ctx.actionAllergy,
      onOnResponseAllergy: _ctx.onResponseAllergy
    }, null, 8, ["params", "action", "onOnResponseAllergy"])
  ], 64))
}